export default "__VITE_ASSET__CcCW2NTO__"